import React, { useCallback, useEffect, useState } from "react";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { Link } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import { set } from "lodash";
import Environment from "../../utils/Environment";
import GetBalance from "../../hooks/refund_contract_call/getBalance";
import { useWeb3React } from "@web3-react/core";
import useAutoChainSwitch from "../../hooks/useAutoChainSwitch";
import Allowance from "../../hooks/refund_contract_call/allowance";
import { toast } from "react-toastify";
import Approve from "../../hooks/refund_contract_call/approve";
import CreditRefund from "../../hooks/refund_contract_call/creditRefund";
import RefundHistoryTable from "./RefundHistoryTable";
import { requestWithState } from "../../@api/requestWithState";
import Signature from "../../hooks/userSign";
import Loader from "../../hooks/loader";
import { useTranslation } from "react-i18next";

const Refundtables = ({
  data,
  claimRefund,
  claimLoader,
  setClaimLoader,
  signCredit,
  fetchPurchases,
  isPremium,
  navigator,
  country,
  getBalance,
  refundTransactions,
  expiryInfo,
  creditPurchases,
  fetchRefundTransactions,
  fetchExpiryInfo,
  fetchCreditPurchases,
  earlyAccessModal,
  setEarlyAccessModal,
  earlyAccessModal2,
  setEarlyAccessModal2,
  whiteList,
  setShow_Nav,
  setShow5,
  email,
  setEmail,
  verified,
  setVerified,
}) => {
  console.log(isPremium, "Is premium");
  const { t } = useTranslation();
  const [key, setKey] = useState("eligiblepurchases");
  const [error, setError] = useState("");
  const [show, setShow] = useState(false);
  const [creditTerms, setShowCreditTerms] = useState(false);
  const [IsTermsAccepted, setTermsAccepted] = useState(false);
  const [availableBalance, setAvailableBalance] = useState(0);
  const [dollarAmount, setDollarAmount] = useState(null);
  const [tokens, setTokens] = useState(null);
  const [show2, setShow2] = useState(false);
  const [show3, setShow3] = useState(false);
  const [show4, setShow4] = useState(false);
  const [selectedPurchase, setSelectedPurchase] = useState(null);
  const [maxTokens, setMaxTokens] = useState(null);
  const { account, chainId } = useWeb3React();
  const { allowance } = Allowance();
  const { GetBal } = GetBalance();
  const { approve } = Approve();
  const { Credit_Refund } = CreditRefund();
  const { userSign } = Signature();
  const [signLoader, setSignLoader] = useState("");
  const [walletBalance, setWalletBalance] = useState(0);
  const [precalculatedRefunds, setPrecalculatedRefunds] = useState([]);
  const [showNotice, setShowNotice] = useState(false);

  const [showEarlyAccessModal, setShowEarlyAccessModal2] = useState(false);

  const [otp, setOtp] = useState("");
  const [isEmailValid, setIsEmailValid] = useState(false);
  const [showOtpInput, setShowOtpInput] = useState(false);
  const [isOtpValid, setIsOtpValid] = useState(true);
  const [showverify, setShowVerify] = useState(false);

  // const [isSecondChecked, setIsSecondChecked] = useState(false);
  // const [isThirdChecked, setIsThirdChecked] = useState(false);

  useEffect(() => {
    console.log(earlyAccessModal, "Early access");
  }, [earlyAccessModal]);
  // useEffect(() => {
  //   console.log(isPremium, "Is premium");

  //   if (isPremium === false) {
  //     setShow(true);   // show only if explicitly false
  //   } else {
  //     setShow(false);  // hide if true or null
  //   }
  // }, [isPremium]);

  // useAutoChainSwitch(11155111); // defaults to 11155111, or pass a custom one

  const calculatePreRefundData = useCallback(async () => {
    if (!account || !data) return;

    // Step 1: Consolidate duplicate items by tokenSymbol
    const consolidatedData = {};

    data.forEach((item) => {
      const tokenSymbol = item?.privateSale;

      if (tokenSymbol !== 'LEIA') return;
      // Initialize if first occurrence of this token
      if (!consolidatedData[tokenSymbol]) {
        consolidatedData[tokenSymbol] = {
          ...item,
          // Initialize counters
          consolidatedTokens: 0,
          consolidatedSaleValue: 0,
        };
      } else {
        // Merge data from duplicate items - preserve non-numerical fields
        consolidatedData[tokenSymbol] = {
          ...consolidatedData[tokenSymbol],
          ...item,
          // Keep existing consolidated values
          consolidatedTokens: consolidatedData[tokenSymbol].consolidatedTokens,
          consolidatedSaleValue:
            consolidatedData[tokenSymbol].consolidatedSaleValue,
          // Keep the most complete creditRefundableProjects and stats
          creditRefundableProjects:
            item.creditRefundableProjects ||
            consolidatedData[tokenSymbol].creditRefundableProjects,
          totalCreditIssuedStats:
            item.totalCreditIssuedStats ||
            consolidatedData[tokenSymbol].totalCreditIssuedStats,
          creditIssuedStats:
            item.creditIssuedStats ||
            consolidatedData[tokenSymbol].creditIssuedStats,
        };
      }

      // Extract token amounts (item will have either tokens or dopPurchased)
      const tokenAmount = (item.tokens || 0) + (item.dopPurchased || 0);

      // Calculate sale value (item will have either price or totalSaleConverted)
      let saleValue = 0;
      if (item.price && item.tokens) {
        // For whitelist entries: price * tokens
        saleValue = item.price * item.tokens;
      } else if (item.totalSaleConverted) {
        // For non-whitelist entries: use totalSaleConverted directly
        saleValue = item.totalSaleConverted;
      }

      // Update consolidated values
      consolidatedData[tokenSymbol].consolidatedTokens += tokenAmount;
      consolidatedData[tokenSymbol].consolidatedSaleValue += saleValue;
    });

    // Step 2: Process each consolidated item
    const results = await Promise.all(
      Object.values(consolidatedData).map(async (item) => {
        const tokenSymbol = item?.privateSale;

        const tokenAddress = {
          DOP: Environment.DOP,
          GEMS: Environment.GEMS,
          LEIA: Environment.LEIA,
        }[tokenSymbol];

        let walletBalance = 0;
        const checkWalletBalance = ["DOP", "LEIA", "GEMS"].includes(
          tokenSymbol
        );

        if (checkWalletBalance && tokenAddress) {
          try {
            walletBalance = await GetBal(tokenAddress);
          } catch (e) {
            console.error("Wallet balance fetch failed", e);
          }
        }

        const project = item.creditRefundableProjects?.[0] || {};
        const globalRefundLimit = project.refundLimit || 0;
        const userRefundLimit = project.refundLimitPerUser || 0;

        const globalTokensUsed =
          item.totalCreditIssuedStats?.[0]?.tokenRefunded || 0;
        const userTokensUsed = item.creditIssuedStats?.[0]?.tokenRefunded || 0;

        const remainingGlobal = globalRefundLimit - globalTokensUsed;
        const remainingUser = userRefundLimit - userTokensUsed;
        const baseLimit = Math.min(remainingGlobal, remainingUser);

        // Use our consolidated token value
        const purchasedTokens = item.consolidatedTokens;

        // Calculate effective rate based on consolidated data
        const rate =
          purchasedTokens > 0
            ? item.consolidatedSaleValue / purchasedTokens
            : 0;

        const refundablePurchasedTokens = Math.max(
          0,
          purchasedTokens - userTokensUsed
        );
        const hasRefundRemaining = refundablePurchasedTokens > 0;

        const maxTokens = checkWalletBalance
          ? Math.max(
              0,
              Math.min(walletBalance, refundablePurchasedTokens, baseLimit)
            )
          : Math.max(0, Math.min(refundablePurchasedTokens, baseLimit));

        const availableAmount = maxTokens * rate;

        // Return the original item with our calculated fields
        return {
          ...item,
          // Original calculated fields
          walletBalance,
          maxTokens,
          availableAmount,
          hasRefundRemaining,
          // New consolidated fields
          tokens: item.consolidatedTokens,
          totalSaleConverted: item.consolidatedSaleValue,
          effectiveRate: rate,
        };
      })
    );

    setPrecalculatedRefunds(results);
  }, [data, account]);

  useEffect(() => {
    if (data?.length) {
      calculatePreRefundData();
    } else {
      setPrecalculatedRefunds([]);
    }
  }, [data, calculatePreRefundData]);

  const onChain = async (data) => {
    await requestWithState({
      url: `/credit/onchain`,
      method: "POST",
      data: data,
    });
  };

  useEffect(() => {
    console.log("email", email);
  }, [email]);

  // Reset all relevant states
  const resetAllStates = () => {
    setError("");
    setAvailableBalance(0);
    setDollarAmount(0);
    setTokens(0);
    setMaxTokens(0);
    setSelectedPurchase(null);
    setTermsAccepted(false);
    setClaimLoader(false);
    setEmail("");
  };

  // Modal 1 handlers
  const handleClose = () => {
    setShow(false);
    resetAllStates();
  };
  const handleShow = () => setShow(true);

  // Credit Terms modal handlers
  const handleCloseCreditTerms = () => {
    setShowCreditTerms(false);
    setTermsAccepted(false);
    // setIsSecondChecked(false)
    // setIsThirdChecked(false)
  };
  const handleShowCreditTerms = (item, pre) => {
    if (earlyAccessModal2) {
      setShowEarlyAccessModal2(false);
      return;
    }
    console.log("i m premium", pre);
    setSelectedPurchase(item);

    if (item?.privateSale == "DOP") {
      setShowNotice(true);
    } else if (!verified) {
      handleShowVerify();
      // setShowCreditTerms(true);
    } else if (verified) {
      setShowCreditTerms(true);
    }
  };

  // Modal 2 handlers
  const handleClose2 = (flag = false) => {
    setShow2(false);
    if (!flag) {
      resetAllStates();
    }
  };
  const handleShow2 = () => {
    setShow2(true);

    const balance = GetBal(Environment.DOP);
    if (balance) {
    }
  };

  // Modal 3 handlers
  const handleClose3 = () => {
    setShow3(false);
    fetchPurchases();
    getBalance();
    fetchRefundTransactions();
    fetchExpiryInfo();
    fetchCreditPurchases();
    resetAllStates();
    // setShow5(true)
  };
  const handleShow3 = () => setShow3(true);

  // Modal 4 handlers
  const handleClose4 = () => {
    setShow4(false);
    resetAllStates();
  };
  const handleShow4 = () => setShow4(true);

  const setMaxValue = () => {
    setTokens(selectedPurchase?.maxTokens);
    setDollarAmount(selectedPurchase?.availableAmount);
  };

  const formatNumber = (num) => {
    if (num && num >= 1_000_000_000) {
      return (num / 1_000_000_000).toFixed(1).replace(/\.0$/, "") + "B";
    } else if (num >= 1_000_000) {
      return (num / 1_000_000).toFixed(1).replace(/\.0$/, "") + "M";
    } else if (num >= 1_000) {
      return (num / 1_000).toFixed(1).replace(/\.0$/, "") + "K";
    } else {
      return num?.toFixed(2);
    }
  };

  const setTokenAmount = (e) => {
    let inputValue = e.target.value;

    // Remove all characters except numbers and one decimal point
    const cleanedValue = inputValue.replace(/[^0-9.]/g, "");

    // Ensure only one decimal point
    const parts = cleanedValue.split(".");
    const numericValue =
      parts.length > 2
        ? parts[0] + "." + parts.slice(1).join("")
        : cleanedValue;

    const tokenCount = Number(numericValue);

    // Determine per-token rate depending on whitelist flow
    // const pricePerToken = whiteList
    //   ? (selectedPurchase?.price ?? 0)
    //   : (
    //     selectedPurchase?.dopPurchased > 0
    //       ? selectedPurchase.totalSaleConverted / selectedPurchase.dopPurchased
    //       : 0
    //   );

    const calculatedAmount = selectedPurchase?.effectiveRate * tokenCount;

    if (calculatedAmount > (selectedPurchase?.availableAmount ?? 0)) {
      setError("Value cannot be greater than available balance");
      return;
    }

    setError("");
    setTokens(numericValue); // retain raw string for input control
    setDollarAmount(calculatedAmount);
  };

  async function refund(privateSale, tokens = 5) {
    let error = false;
    const isTokenSale = ["DOP", "GEMS", "LEIA"].includes(privateSale);

    try {
      setClaimLoader(true); // ✅ Start loader
      setSignLoader("Please approve signature transaction first...");
      const sign = await userSign();
      setSignLoader("");

      if (isTokenSale) {
        // Determine token address based on the privateSale token
        const tokenAddress = {
          DOP: Environment.DOP,
          GEMS: Environment.GEMS,
          LEIA: Environment.LEIA,
        }[privateSale];

        setSignLoader("Checking Balance...");
        const balance = await GetBal(tokenAddress);
        console.log(balance);

        if (balance < tokens) {
          throw "INSUFFICIENT_BALANCE";
        }

        setSignLoader("Checking Allowance...");
        const allowedTokens = await allowance(tokenAddress, 18);
        console.log(allowedTokens, "allowedTokens");

        if (allowedTokens < tokens) {
          setSignLoader("Approving Tokens...");
          const approvalResult = await approve(tokens, tokenAddress, 18);
          console.log(approvalResult, "Approve Result");
        }

        const signCreditData = await signCredit(
          sign,
          account,
          privateSale,
          tokens
        );
        console.log(signCreditData, "data");
        setSignLoader("Processing Transaction...");

        const data = await Credit_Refund(
          signCreditData?.amount,
          signCreditData?.tokenSelected,
          signCreditData?.totalAmount,
          signCreditData?.deadline,
          signCreditData?.v,
          signCreditData?.r,
          signCreditData?.s,
          18
        );
        console.log(data);

        const expiredAt = new Date();
        expiredAt.setUTCFullYear(expiredAt.getUTCFullYear() + 1);

        await onChain({
          transactionHash: data?.transactionHash?.toLowerCase(),
          privateSale,
          tokenRefunded: tokens,
          creditRefunded: dollarAmount,
          country,
          by: account?.toLowerCase(),
          price: signCreditData?.price,
          expiredAt,
          email: email,
        });

        console.log("Refund successful:", data);
        // setShow5(true)
      } else {
        // For other non-token based sales
        await claimRefund(privateSale, tokens, sign, email);
      }

      if (!error) {
        handleShow3();
      }
    } catch (err) {
      error = true;
      console.log(err, "Refund error");
      if (err === "INSUFFICIENT_BALANCE") {
        toast.error("Insufficient balance to proceed with refund");
      } else {
        toast.error("User rejected the transaction");
      }
      // setShow5(false)
      resetAllStates();
    } finally {
      console.log("Finally");
      setClaimLoader(false); // ✅ Always stop loader
      handleClose2(true);
      // ✅ Close modal
    }
  }

  const handleCloseVerify = (flag) => {
    if (flag) {
      // setEmail("")
      setShowCreditTerms(true);
    } else {
      setEmail("");
    }
    setShowOtpInput(false);
    setShowVerify(false);
    setOtp("");
  };
  const handleShowVerify = () => {
    console.log(verified, "Verified");
    if (!verified) {
      setShowVerify(true);
    } else {
      // handleCloseVerify(true, opened)
      setShowCreditTerms(true);
    }
  };

  const isValidEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const handleEmailChange = (e) => {
    const value = e.target.value;
    setEmail(value);
    setIsEmailValid(isValidEmail(value));
  };

  const [timer, setTimer] = useState(0);
  const [isResendDisabled, setIsResendDisabled] = useState(false);

  useEffect(() => {
    let countdown;
    if (timer > 0) {
      countdown = setTimeout(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    } else if (timer === 0 && isResendDisabled) {
      setIsResendDisabled(false);
    }
    return () => clearTimeout(countdown);
  }, [timer, isResendDisabled]);

  const handleSendCode = async (e) => {
    e.preventDefault();
    if (!isEmailValid || isResendDisabled) return;

    try {
      const response = await requestWithState({
        url: `/emails/verify-email`,
        method: "POST",
        data: {
          email,
          by: account.toLowerCase(),
          country,
        },
      });

      console.log(response);
      if (response?.statusCode === 200) {
        console.log("Email already verified.");
        setShowOtpInput(false);
        handleCloseVerify(true);
      } else if (response?.statusCode === 201) {
        console.log("Verification email sent.");
        toast.success("Verification email sent.");
        setShowOtpInput(true);

        // Start cooldown
        setIsResendDisabled(true);
        setTimer(10);
      } else if (response?.statusCode === 409) {
        toast.error("Email already exists");
      } else if (response?.statusCode === 409) {
        toast.error("Email already exists");
      } else if (response?.statusCode === 403) {
        toast.error("Given wallet address is associated with existing email");
      }
    } catch (error) {
      // toast.error(error.message)
      console.error("Failed to send verification email:", error);
    }
  };

  const handleVerifyOtp = async () => {
    try {
      const response = await requestWithState({
        url: `/emails/verify-otp`,
        method: "POST",
        data: {
          email,
          by: account.toLowerCase(),
          otp,
        },
      });

      if (response?.statusCode === 201) {
        setVerified(true);
        console.log("Email verified successfully");
        setIsOtpValid(true);
        handleCloseVerify(true);
      } else {
        setIsOtpValid(false);
      }
    } catch (error) {
      console.error("OTP verification failed:", error);
      setIsOtpValid(false);
    }
  };

  if (claimLoader) {
    return <Loader text={signLoader} />;
  }

  return (
    <>
      {/* <button onClick={() => { refund('GEMS' ) }}>CHECK BUTTON</button> */}

      <section
        className="gems-purchases credittables"
        style={{ padding: "30px 0 60px" }}
      >
        <div className="custom-container">
          <Tabs
            id="controlled-tab-example"
            activeKey={key}
            onSelect={(k) => setKey(k)}
            className="signup-nav refundnav"
          >
            <Tab eventKey="eligiblepurchases" title={t("eligiblepurchases")}>
              <div className="table-heading">
                <p className="para">{t("Cre6")}</p>
              </div>
              {precalculatedRefunds?.length > 0 ? (
                <div className="custom-table d-noneformobile">
                  <div class="table-responsive">
                    <table className="table m-0">
                      <thead>
                        <tr>
                          <th>{t("Cre7")}</th>
                          <th className="text-center">{t("Cre8")}</th>
                          <th className="text-center">{t("Cre9")}</th>
                          <th className="text-center">{t("Cre10")}</th>
                          <th className="text-center">{t("Cre11")}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {precalculatedRefunds?.map((item) => {
                          const hasRefundLeft = item.maxTokens > 0;

                          return (
                            <tr key={item.privateSale}>
                              <td>
                                <div className="twice-items">
                                  <img
                                    src={`https://media-gems.gems.vip/logos/${item?.privateSale.toLowerCase()}.svg`}
                                    alt="img"
                                    className="img-fluid"
                                  />
                                  <h6>{item?.privateSale}</h6>
                                </div>
                              </td>
                              <td className="text-center">
                                {item?.tokens?.toLocaleString(undefined, {
                                  minimumFractionDigits: 5,
                                  maximumFractionDigits: 5,
                                })}
                              </td>
                              <td className="text-center">
                                ${formatNumber(item?.totalSaleConverted)}
                              </td>
                              <td className="text-center">
                                {item?.creditIssuedStats?.[0]?.tokenRefunded?.toLocaleString() ||
                                  0}
                              </td>
                              <td className="text-center">
                                {isPremium && !item.hasRefundRemaining ? (
                                  <button
                                    disabled
                                    className="btn-claim refundbtn"
                                  >
                                    {t("Cre12")}
                                  </button>
                                ) : (
                                  <button
                                    onClick={() =>
                                      isPremium
                                        ? handleShowCreditTerms(item, isPremium)
                                        : handleShow()
                                    }
                                    className="btn-claim refundbtn"
                                  >
                                    {t("Cre13")}
                                  </button>
                                )}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              ) : (
                <>
                  <div className="tabledatanotfound">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="37"
                      height="36"
                      viewBox="0 0 37 36"
                      fill="none"
                    >
                      <path
                        d="M18.5 33C26.7843 33 33.5 26.2843 33.5 18C33.5 9.71573 26.7843 3 18.5 3C10.2157 3 3.5 9.71573 3.5 18C3.5 26.2843 10.2157 33 18.5 33Z"
                        stroke="#329879"
                        stroke-width="4"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M7.84961 7.3501L29.1496 28.6501"
                        stroke="#329879"
                        stroke-width="4"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    <h6 style={{ maxWidth: "241px" }}>
                      Refunds for eligible purchases are no longer available
                    </h6>
                  </div>
                </>
              )}

              {/* <div className="mobiletable d-none">
                <div className="innerbox">
                  <div className="innerboxhead">
                    <div className="tokenimg">
                      <img
                        src="/assets/creditrefund/olympus.svg"
                        alt="innertokenimg"
                        className="innertokenimg"
                      />
                    </div>
                    <p className="tokenname">Olympus AI</p>
                  </div>
                  <div className="innerboxbody">
                    <div className="inneritemmain">
                      <div className="inneritem">
                        <p className="itempara">AMOUNT PURCHASED</p>
                        <h6 className="itemhead">2,454,667 OAI</h6>
                      </div>
                      <div className="inneritem">
                        <p className="itempara">Amount Spent</p>
                        <h6 className="itemhead">$2.56K</h6>
                      </div>
                    </div>
                    <button onClick={handleShow4} className="btn-claim refundbtn">
                      Get a Refund
                    </button>
                  </div>
                </div>
                <div className="innerbox">
                  <div className="innerboxhead">
                    <div className="tokenimg">
                      <img
                        src="/assets/creditrefund/olympus.svg"
                        alt="innertokenimg"
                        className="innertokenimg"
                      />
                    </div>
                    <p className="tokenname">Olympus AI</p>
                  </div>
                  <div className="innerboxbody">
                    <div className="inneritemmain">
                      <div className="inneritem">
                        <p className="itempara">AMOUNT PURCHASED</p>
                        <h6 className="itemhead">2,454,667 OAI</h6>
                      </div>
                      <div className="inneritem">
                        <p className="itempara">Amount Spent</p>
                        <h6 className="itemhead">$2.56K</h6>
                      </div>
                    </div>
                    <button disabled className="btn-claim refundbtn">
                      Refund Claimed
                    </button>
                  </div>
                </div>
              </div> */}

              <div className="mobiletable d-none">
                {precalculatedRefunds?.map((item, index) => {
                  const hasRefundLeft = item.maxTokens > 0;
                  const refundButtonDisabled = isPremium && !hasRefundLeft;

                  return (
                    <div className="innerbox" key={index}>
                      <div className="innerboxhead">
                        <div className="tokenimg">
                          <img
                            src={`https://media-gems.gems.vip/logos/${item?.privateSale.toLowerCase()}.svg`}
                            alt="innertokenimg"
                            className="innertokenimg"
                          />
                        </div>
                        <p className="tokenname">{item?.privateSale}</p>
                      </div>

                      <div className="innerboxbody">
                        <div className="inneritemmain">
                          <div className="inneritem">
                            <p className="itempara">{t("Cre8")}</p>
                            <h6 className="itemhead">
                              {item?.tokens?.toLocaleString(undefined, {
                                minimumFractionDigits: 5,
                                maximumFractionDigits: 5,
                              })}
                            </h6>
                          </div>
                          <div className="inneritem">
                            <p className="itempara">{t("Cre9")}</p>$
                            {formatNumber(item?.totalSaleConverted)}
                          </div>
                        </div>

                        <td className="text-center">
                          {isPremium && !item.hasRefundRemaining ? (
                            <button disabled className="btn-claim refundbtn">
                              {t("Cre12")}
                            </button>
                          ) : (
                            <button
                              onClick={() =>
                                isPremium
                                  ? handleShowCreditTerms(item, isPremium)
                                  : handleShow()
                              }
                              className="btn-claim refundbtn"
                            >
                              {t("Cre13")}
                            </button>
                          )}
                        </td>
                      </div>
                    </div>
                  );
                })}
              </div>
            </Tab>
            <Tab eventKey="history" title={t("credithis")}>
              <Tabs
                defaultActiveKey="refunds"
                id="uncontrolled-tab-example"
                className="tabs-credit-history"
              >
                <Tab eventKey="refunds" title={t("refund")}>
                  <RefundHistoryTable
                    refundData={refundTransactions}
                    type="refunds"
                  />
                </Tab>
                <Tab eventKey="purchase" title={t("purchases")}>
                  <RefundHistoryTable
                    refundData={creditPurchases}
                    type="purchases"
                  />
                </Tab>
                <Tab eventKey="expired" title={t("expired")}>
                  <RefundHistoryTable refundData={expiryInfo} type="expired" />
                </Tab>
              </Tabs>
            </Tab>
          </Tabs>
        </div>
      </section>

      <Modal
        className="fundsmodal common-modal-style"
        show={show}
        onHide={handleClose}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>{t("Cre19")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="maincontent">
            <div className="upperimg">
              <img
                src="\assets\redcrossimg.png"
                alt="img"
                className="crossimg img-fluid"
              />
            </div>
            <p className="maxwidthset">{t("Cre20")}</p>
            <div className="lastbutton">
              <button
                className="cancle"
                onClick={() => {
                  handleClose();
                }}
              >
                {t("pre28")}
              </button>
              <button
                className="get"
                onClick={() => {
                  handleClose();
                  navigator();
                }}
              >
                {t("Cre5")}{" "}
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="fundsmodal common-modal-style"
        show={show2}
        onHide={handleClose2}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>{t("CreditRefund")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="maincontent">
            <div className="refund-box">
              <div className="token-info">
                <img
                  src={`https://media-gems.gems.vip/logos/${selectedPurchase?.privateSale.toLowerCase()}.svg`}
                  alt="img"
                  className="img-fluid"
                  width={"30px"}
                  height={"30px"}
                />
                <h6> {selectedPurchase?.privateSale}</h6>
              </div>
              <div className="purchased-info">
                <div className="single-purchase">
                  <p>{t("Cre22")}</p>
                  <h6>
                    {
                      // whiteList
                      selectedPurchase?.tokens?.toLocaleString(undefined, {
                        minimumFractionDigits: 5,
                        maximumFractionDigits: 5,
                      })
                      // : selectedPurchase?.dopPurchased?.toLocaleString(undefined, { minimumFractionDigits: 5, maximumFractionDigits: 5 })
                    }{" "}
                    {selectedPurchase?.privateSale}
                    <span>
                      {
                        // '$' + formatNumber(
                        // whiteList
                        // selectedPurchase?.tokens * selectedPurchase?.price
                        "$" +
                          selectedPurchase?.totalSaleConverted?.toLocaleString(
                            (undefined,
                            {
                              minimumFractionDigits: 5,
                              maximumFractionDigits: 5,
                            })
                          )
                      }
                    </span>
                  </h6>
                </div>
                <div className="single-purchase">
                  <p>{t("Cre23")}</p>
                  <h6>
                    {selectedPurchase?.maxTokens?.toLocaleString(undefined, {
                      minimumFractionDigits: 5,
                      maximumFractionDigits: 5,
                    }) +
                      " " +
                      selectedPurchase?.privateSale}
                  </h6>
                </div>
              </div>
            </div>
            {/* <div className="olympusbox">
              <div className="left">
                <p>
                  <img
                    src={`https://media-gems.gems.vip/logos/${selectedPurchase?.privateSale.toLowerCase()}.svg`}
                    alt="img"
                    className="img-fluid"
                    width={'30px'}
                    height={'30px'}
                  />
                  {selectedPurchase?.privateSale}
                </p>
              </div> */}
            {/* <div className="right">
                <p className="text-end">Total Purchased</p>
                <h6> {selectedPurchase?.dopPurchased?.toFixed(5) + ' $' + selectedPurchase?.privateSale}</h6>
                <p>{'$' + formatNumber(selectedPurchase?.totalSaleConverted)}</p>
              </div>
            </div> */}

            <div className="amountboxparent">
              <div className="firstamout">
                <div className="right">
                  <h6>{t("Cre24")}</h6>
                  <input
                    type="text"
                    placeholder="0"
                    value={tokens === 0 ? "" : tokens}
                    onChange={setTokenAmount}
                  />

                  <p className="m-0 text-start">~${dollarAmount}</p>
                </div>

                <div className="left">
                  {/* <p>Available: {selectedPurchase?.privateSale + ' ' + selectedPurchase?.maxTokens?.toFixed(5)}</p> */}
                  <button onClick={setMaxValue}>{t("Cre25")}</button>
                </div>
              </div>

              <span className="arrowimg">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="19"
                  height="19"
                  viewBox="0 0 19 19"
                  fill="none"
                >
                  <path
                    d="M2.23621 9.95642L2.23621 12.8487L9.24455 16.7719L9.24455 13.8796L2.23621 9.95642Z"
                    fill="#02171D"
                  />
                  <path
                    d="M16.2676 9.95642L16.2676 12.8487L9.25924 16.7719L8.04764 14.9491L9.25924 13.8796L16.2676 9.95642Z"
                    fill="#02171D"
                  />
                  <path
                    d="M7.92847 9.80906L7.92847 1.77884L10.5713 3.25274L10.5713 11.283L7.92847 9.80906Z"
                    fill="#02171D"
                  />
                </svg>
              </span>

              <div className="firstamout forbg">
                <div className="right">
                  <h6>{t("Cre26")}</h6>
                  <input
                    type="text"
                    placeholder="0"
                    value={
                      !dollarAmount
                        ? ""
                        : Number(dollarAmount).toLocaleString(undefined, {
                            minimumFractionDigits: 5,
                            maximumFractionDigits: 5,
                          })
                    }
                    disabled
                  />
                </div>
                <div className="left">
                  <p className="formmm">
                    {t("Cre27")}: $
                    {selectedPurchase?.availableAmount?.toLocaleString(
                      undefined,
                      { minimumFractionDigits: 5, maximumFractionDigits: 5 }
                    )}
                  </p>
                </div>
              </div>
            </div>
            {!!error && (
              <div className="form-error-msg">
                <p className="text-danger">{t("Cre28")}</p>
              </div>
            )}

            <div className="yellowbox">
              <p className="text">
                {t("Cre29")} <span>1 {t("Cre30")}</span> {t("Cre31")}
              </p>
            </div>

            <div className="lastbtn">
              <button
                className="close"
                onClick={() => {
                  handleClose2();
                  handleShowCreditTerms();
                }}
              >
                {t("pre28")}
              </button>

              <button
                className="continue"
                disabled={!tokens || claimLoader}
                onClick={() => refund(selectedPurchase?.privateSale, tokens)}
                style={
                  !tokens || claimLoader
                    ? { opacity: 0.5, pointerEvents: "none" }
                    : {}
                }
              >
                {claimLoader ? t("Cre32") + "..." : t("pre29")}
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="fundsmodal common-modal-style"
        show={show3 && !claimLoader}
        onHide={handleClose3}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>{t("pre30")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="maincontent">
            <div className="upperimg">
              <img
                src="\assets\greenticck.png"
                alt="img"
                className="crossimg img-fluid"
              />
            </div>
            <h3 className="refundtext">{t("Cre33")}</h3>
            <p className="credittext">
              {dollarAmount?.toFixed(5)} {t("Cre34")} <br /> {t("Cre35")}
            </p>
            <button onClick={handleClose3} className="ok">
              OK
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="fundsmodal common-modal-style"
        show={show4}
        onHide={handleClose4}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>{t("CreditRefund")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="maincontent">
            <h3 className="followtext">{t("pre35")}!</h3>
            <p className="paramain">{t("Cre36")}</p>
            <div className="parentsocialicons">
              <div className="first">
                <span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                    <path
                      d="M11.9024 1.90625H13.9699L9.45307 7.06875L14.7668 14.0938H10.6062L7.34744 9.83312L3.61869 14.0938H1.54994L6.38119 8.57188L1.28369 1.90625H5.54994L8.49557 5.80062L11.9024 1.90625ZM11.1768 12.8563H12.3224L4.92744 3.07875H3.69807L11.1768 12.8563Z"
                      fill="#02171D"
                    />
                  </svg>
                </span>
                <p className="bottomtext">X</p>
              </div>
              <div className="first">
                <span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                    <g clip-path="url(#clip0_8634_75595)">
                      <path
                        d="M6.38574 9.98789L6.13761 13.4779C6.49261 13.4779 6.64636 13.3254 6.83074 13.1423L8.49511 11.5516L11.9439 14.0773C12.5764 14.4298 13.022 14.2441 13.1926 13.4954L15.4564 2.88789L15.457 2.88727C15.6576 1.95227 15.1189 1.58664 14.5026 1.81602L1.19636 6.91039C0.288236 7.26289 0.301986 7.76914 1.04199 7.99852L4.44386 9.05664L12.3457 4.11227C12.7176 3.86602 13.0557 4.00227 12.7776 4.24852L6.38574 9.98789Z"
                        fill="#ECF5F9"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_8634_75595">
                        <rect
                          width="15"
                          height="15"
                          fill="white"
                          transform="translate(0.5 0.5)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                </span>
                <p className="bottomtext">Telegram</p>
              </div>
              <div className="first">
                <span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                    <g clip-path="url(#clip0_8634_75600)">
                      <path
                        d="M2.6668 1.26172C1.63563 1.26172 0.961426 1.93884 0.961426 2.82882C0.961426 3.69914 1.61554 4.39557 2.62723 4.39557H2.6468C3.69814 4.39557 4.35242 3.69914 4.35242 2.82882C4.33277 1.93884 3.69814 1.26172 2.6668 1.26172Z"
                        fill="#02171D"
                      />
                      <path
                        d="M1.13965 5.63379H4.15419V14.7032H1.13965V5.63379Z"
                        fill="#02171D"
                      />
                      <path
                        d="M11.5534 5.4209C9.92713 5.4209 8.83665 6.94903 8.83665 6.94903V5.63376H5.82202V14.7031H8.83648V9.63845C8.83648 9.36731 8.85614 9.0966 8.93579 8.90271C9.15371 8.36129 9.64964 7.80038 10.4825 7.80038C11.5733 7.80038 12.0096 8.63208 12.0096 9.85131V14.7031H15.0238V9.50292C15.0238 6.7172 13.5366 5.4209 11.5534 5.4209Z"
                        fill="#02171D"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_8634_75600">
                        <rect
                          width="15"
                          height="15"
                          fill="white"
                          transform="translate(0.5 0.5)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                </span>
                <p className="bottomtext">LinkedIn</p>
              </div>
              <div className="first">
                <span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                    <path
                      d="M14.8749 6.56892C14.9058 5.67433 14.7102 4.78643 14.3061 3.98767C14.032 3.65992 13.6516 3.43874 13.2311 3.36267C11.4921 3.20488 9.74585 3.1402 7.99989 3.16892C6.2603 3.1389 4.52034 3.20149 2.78739 3.35642C2.44478 3.41875 2.12772 3.57945 1.87489 3.81892C1.31239 4.33767 1.24989 5.22517 1.18739 5.97517C1.09671 7.32365 1.09671 8.6767 1.18739 10.0252C1.20548 10.4473 1.26833 10.8663 1.37489 11.2752C1.45025 11.5908 1.60272 11.8829 1.81864 12.1252C2.07319 12.3773 2.39763 12.5472 2.74989 12.6127C4.09734 12.779 5.45503 12.8479 6.8124 12.8189C8.9999 12.8502 10.9186 12.8189 13.1874 12.6439C13.5483 12.5825 13.8819 12.4124 14.1436 12.1564C14.3186 11.9814 14.4493 11.7671 14.5249 11.5314C14.7484 10.8456 14.8582 10.1277 14.8499 9.40642C14.8749 9.05642 14.8749 6.94392 14.8749 6.56892ZM6.58739 9.78142V5.91267L10.2874 7.85642C9.24989 8.43142 7.88114 9.08142 6.58739 9.78142Z"
                      fill="#02171D"
                    />
                  </svg>
                </span>
                <p className="bottomtext">Youtube</p>
              </div>
            </div>
            <div className="lastbtn">
              <button className="close">{t("Cre38")}</button>
              <button
                onClick={() => {
                  handleClose4();
                  handleShow2();
                }}
                className="continue"
              >
                {t("Cre37")}
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="common-modal-style connectwallet-modal nooreee learnmore-modal"
        show={creditTerms}
        onHide={handleCloseCreditTerms}
        centered
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {" "}
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="25"
                viewBox="0 0 24 25"
                fill="none"
              >
                <rect y="0.5" width="24" height="24" rx="4" fill="#E88F35" />
                <path
                  d="M10.0001 2.5L13.4199 4.40802L13.5063 17.6429L10.0866 15.7348L10.0001 2.5Z"
                  fill="white"
                />
                <path
                  d="M9.9999 17.604L13.4196 19.512L13.5061 21.604L10.0864 19.696L9.9999 17.604Z"
                  fill="white"
                />
              </svg>
              {t("Cre39")}
            </div>{" "}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0">
          <div className="disclaimerdiv">
            <div className="darktext">
              <div className="scrolltext">
                <p className="darkparaupper text-center">{t("Cre40")}</p>
                <p className="darkpara text-center">
                  {t("Cre41")} 28 April 2025
                </p>
                <p className="darkpara">
                  1.
                  <span className="headingtext formarginleft">
                    {t("Cre42")}
                  </span>
                </p>
                <p className="darkpara">{t("Cre43")}</p>

                <p className="darkpara">
                  2.
                  <span className="headingtext formarginleft">
                    {t("Cre44")}
                  </span>
                </p>
                <p className="darkpara">{t("Cre45")}</p>

                <p className="darkpara">
                  3.
                  <span className="headingtext formarginleft">
                    {t("Cre46")}
                  </span>
                </p>
                <p className="darkpara">{t("Cre47")}</p>

                <p className="darkpara">
                  4.
                  <span className="headingtext formarginleft">
                    {t("Cre48")}
                  </span>
                </p>
                <p className="darkpara">{t("Cre49")}</p>

                <p className="darkpara">
                  5.
                  <span className="headingtext formarginleft">
                    {t("Cre50")}
                  </span>
                </p>
                <p className="darkpara">
                  <span className="headingtext formarginleft">5.1</span>{" "}
                  {t("Cre51")}
                </p>
                <p className="darkpara">
                  <ul>
                    <li>{t("Cre52")}</li>
                    <li>{t("Cre53")}</li>
                    <li>{t("Cre54")}</li>
                    <li>{t("Cre55")}</li>
                    <li>{t("Cre56")} </li>
                  </ul>
                </p>
                <p className="darkpara">
                  <span className="headingtext formarginleft">5.2</span>{" "}
                  {t("Cre57")}
                </p>
                <p className="darkpara">
                  6.
                  <span className="headingtext formarginleft">
                    {t("Cre58")}
                  </span>
                </p>
                <p className="darkpara">{t("Cre59")}</p>

                <p className="darkpara">
                  7.
                  <span className="headingtext formarginleft">
                    {t("Cre60")}
                  </span>
                </p>
                <p className="darkpara">{t("Cre61")}</p>

                <p className="darkpara">
                  8.
                  <span className="headingtext formarginleft">
                    {t("Cre62")}
                  </span>
                </p>
                <p className="darkpara">{t("Cre63")}</p>

                <p className="darkpara">
                  9.
                  <span className="headingtext formarginleft">
                    {t("Cre64")}
                  </span>
                </p>
                <p className="darkpara">{t("Cre65")}</p>

                <p className="darkpara">
                  10.
                  <span className="headingtext formarginleft">
                    {t("Cre66")}
                  </span>
                </p>
                <p className="darkpara">{t("Cre67")}</p>
                <p className="darkpara">
                  11.
                  <span className="headingtext formarginleft">
                    {t("Cre68")}
                  </span>
                </p>
                <p className="darkpara">{t("Cre69")}</p>
              </div>
            </div>

            {/* Email Field */}
            {/* <div className="option-field" style={{ margin: "20px 0" }}>
                  <div className="material-textfield">
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Enter your email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </div>
                </div> */}

            {/* Checkbox */}
            <div className="checkboxmainnnnnn">
              <label className="checkbox m-0" htmlFor="ch1">
                <input
                  type="checkbox"
                  id="ch1"
                  onChange={() => setTermsAccepted(!IsTermsAccepted)}
                  checked={IsTermsAccepted}
                />
                <span className="checkmark"></span>
              </label>
              <p className="checkboxpara">{t("Cre70")}</p>
            </div>

            {/* <div className="checkboxmainnnnnn">
              <label className="checkbox m-0" htmlFor="ch2">
                <input
                  type="checkbox"
                  id="ch2"
                  onChange={() => setIsSecondChecked(!isSecondChecked)}
                  checked={isSecondChecked}
                />
                <span className="checkmark"></span>
              </label>
              <p className="checkboxpara">{"I agree to recieve communication and marketing emails from Gems"}</p>
            </div> */}

            {/* <div className="checkboxmainnnnnn">
              <label className="checkbox m-0" htmlFor="ch3">
                <input
                  type="checkbox"
                  id="ch3"
                  onChange={() => setIsThirdChecked(!isThirdChecked)}
                  checked={isThirdChecked}
                />
                <span className="checkmark"></span>
              </label>
              <p className="checkboxpara">{"I hereby confirm I'm not a citizen of United States of America"}</p>
            </div> */}

            {/* Continue Button */}
            <button
              disabled={!IsTermsAccepted}
              className="continuebutton"
              style={
                !IsTermsAccepted ? { opacity: 0.5, pointerEvents: "none" } : {}
              }
              onClick={() => {
                handleCloseCreditTerms();
                handleShow2();
              }}
            >
              {t("Cre71")}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      {/* <Modal
        className="fundsmodal common-modal-style"
        show={earlyAccessModal}
        onHide={() => {
          setEarlyAccessModal(false);
        }}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Oops</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="maincontent">
            <div className="upperimg">
              <img
                src="\assets\redcrossimg.png"
                alt="img"
                className="crossimg img-fluid"
              />
            </div>
            <h3 className="followtext" style={{ marginTop: "25px" }}>Early Access Denied</h3>
            <p className="maxwidthset" style={{ marginTop: "10px" }}>
              Credit Refund is currently available only to Premium Members who hold 3,000 or more $GEMS tokens.
            </p>
            <div className="lastbutton">
              <button className="cancle"
                onClick={() => {
                  setEarlyAccessModal(false);

                }}>Cancel</button>
              <button
                className="get"
                onClick={() => {
                  setEarlyAccessModal(false);
                }}
              >
                OK{" "}


              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal> */}
      <Modal
        className="fundsmodal common-modal-style"
        show={showNotice}
        onHide={() => setShowNotice(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>{t("Cre72")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="maincontent">
            <div className="upperimg">
              <img
                src="\assets\creditrefund\notice.svg"
                alt="img"
                className="crossimg img-fluid"
              />
            </div>
            <h4
              className="followtext"
              style={{ fontSize: "20px", marginTop: "25px" }}
            >
              {t("Cre73")}
            </h4>
            <p className="maxwidthset">
              {t("Cre74")}
              <br />
              <br />

              {t("Cre75")}
            </p>
            <div className="lastbutton">
              <button
                onClick={() => {
                  window.open("https://t.me/Dop_org/397");
                }}
                className="cancle"
              >
                {t("Cre117")}
              </button>
              <button
                onClick={() => {
                  setShowNotice(false);
                  // setShowCreditTerms(true);
                  handleShowVerify();
                }}
                className="get"
              >
                {t("Cre71")}{" "}
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="fundsmodal common-modal-style"
        show={earlyAccessModal}
        onHide={() => {
          setEarlyAccessModal(false);
        }}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>{t("Cre76")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="maincontent">
            <div className="upperimg">
              <img
                src="\assets\creditrefund\earlyaccess.svg"
                alt="img"
                className="crossimg img-fluid"
              />
            </div>
            <h3 className="followtext" style={{ marginTop: "25px" }}>
              {t("Cre77")} 🎉
            </h3>
            <p className="maxwidthset" style={{ marginTop: "10px" }}>
              {t("Cre78")}
            </p>
            <div className="lastbutton">
              <button
                className="get"
                // onClick={() => {
                //   setEarlyAccessModal(false);
                // }}
                onClick={() => {
                  setEarlyAccessModal(false);
                }}
              >
                {t("Cre71")}{" "}
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* <Modal
        className="fundsmodal common-modal-style"
        show={showEarlyAccessModal}
        onHide={() => {
          setShowEarlyAccessModal2(false);
        }}
        centered
      >
        
        <Modal.Header closeButton>
          <Modal.Title>Early Access</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="maincontent">
            <div className="upperimg">
              <img
                src="\assets\creditrefund\earlyaccess.svg"
                alt="img"
                className="crossimg img-fluid"
              />
            </div>
            <h3 className="followtext" style={{ marginTop: "25px" }}>Credit Refund Early Access 🎉</h3>
            <p className="maxwidthset" style={{ marginTop: "10px" }}>
              Currently, early access is available exclusively to Gems holders with at least 30,000 Gems tokens in their wallet.
            </p>
            <div className="lastbutton">
              <button
                className="get"
                // onClick={() => {
                //   setEarlyAccessModal(false);
                // }}
                onClick={() => {
                  setShowEarlyAccessModal2(false);
                }}
              >
                Continue{" "}


              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal> */}

      <Modal
        className="fundsmodal common-modal-style"
        show={showEarlyAccessModal}
        onHide={() => {
          setShowEarlyAccessModal2(false);
        }}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>{t("Cre19")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="maincontent">
            <div className="upperimg">
              <img
                src="\assets\redcrossimg.png"
                alt="img"
                className="crossimg img-fluid"
              />
            </div>
            <h3 className="followtext" style={{ marginTop: "25px" }}>
              {t("Cre79")}
            </h3>
            <p className="maxwidthset" style={{ marginTop: "10px" }}>
              {t("Cre80")}
            </p>
            <div className="lastbutton">
              <button
                className="cancle"
                onClick={() => {
                  setShowEarlyAccessModal2(false);
                }}
              >
                {t("pre28")}
              </button>
              <button
                className="get"
                onClick={() => {
                  setShowEarlyAccessModal2(false);
                }}
              >
                OK{" "}
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        className="common-modal-style followusonx-modal verificationemail-modal"
        show={showverify}
        onHide={handleCloseVerify}
        centered
        backdrop="static" // prevents closing on outside click
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Email Verification</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="verification-modal">
            <p className="para">
              We will email you a 6-digit code to verify your email address.
              Enter the code below.
            </p>

            <div className="option-field">
              <label>Email Address</label>
              <div className="inside-input">
                <input
                  type="text"
                  placeholder="Enter your email address"
                  value={email}
                  onChange={handleEmailChange}
                />
                <a
                  href="#"
                  className={`btn-send ${
                    !isEmailValid || isResendDisabled ? "disabled" : ""
                  }`}
                  onClick={handleSendCode}
                  style={{
                    pointerEvents:
                      !isEmailValid || isResendDisabled ? "none" : "auto",
                    opacity: !isEmailValid || isResendDisabled ? 0.5 : 1,
                  }}
                >
                  {isResendDisabled ? `Resend in ${timer}s` : "Send Code"}
                </a>
              </div>
            </div>

            <div
              style={{
                opacity: showOtpInput ? 1 : 0.5,
                pointerEvents: showOtpInput ? "auto" : "none",
              }}
            >
              <div className="option-field" style={{ marginTop: "25px" }}>
                <label
                  style={{ color: "var(--V6-Dark-Theme-Secondary-Text-Color)" }}
                >
                  Verification Code
                </label>
                <div className="inside-input">
                  <input
                    type="text"
                    placeholder="Enter 6-digit code here"
                    value={otp}
                    onChange={(e) => setOtp(e.target.value)}
                  />
                </div>
              </div>

              {!isOtpValid && (
                <p className="error-text">Invalid email verification code</p>
              )}

              <div className="twice-btnsss">
                <button
                  className={`btn-green sscscscscscsc ${
                    otp.length !== 6 ? "disabled" : ""
                  }`}
                  style={{ marginTop: "28px" }}
                  onClick={handleVerifyOtp}
                  disabled={otp.length !== 6}
                >
                  Verify Code
                </button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Refundtables;
